import { BundledProductsModel, getBundledProducts } from "@NA/Services/ADIBundledProductsService";
import { CustomHandlerWithResult } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { HasOnSuccess, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { GetProductCollectionApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import loadRealTimeInventory from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import loadProductInfoList from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/LoadProductInfoList";
import { GetBundledProductsApiParameter } from "@insite/client-framework/Types/ApiModels";

interface Props extends BundledProductsModel {
    getProductCollectionParameter?: GetProductCollectionApiV2Parameter;
}

type HandlerType = CustomHandlerWithResult<GetBundledProductsApiParameter & HasOnSuccess, Props>;

export const LoadBundledProducts: HandlerType = async (props: any) => {
    const parameter = props.parameter;
    const { onSuccess, ...apiParameter } = props.parameter;
    props.apiParameter = apiParameter;
    if (!parameter) {
        return false;
    }

    props.result = await getBundledProducts(props.apiParameter);
    props.products = props.result.products;
    if (!props.result) {
        return false;
    }
};

export const MapProducts: HandlerType = (props: any) => {
    props.productInfosByProductId = {};
    props.products?.forEach((o: any) => {
        props.productInfosByProductId[o.id] = {
            productId: o.id,
            qtyOrdered: Math.max(o.minimumOrderQty, 1),
            unitOfMeasure: o.unitOfMeasures?.find((a:any) => a.isDefault)?.unitOfMeasure ?? "",
            productDetailPath: o.canonicalUrl,
        };
    });
};

export const LoadRealTimePrices: HandlerType = async (props: any) => {
    const { products, productInfosByProductId } = props;
    if (!products?.length) {
        props.pricingLoaded = true;
    }

    props.dispatch(
        loadRealTimePricing({
            productPriceParameters: products!.map((o: any) => ({
                productId: o.id,
                unitOfMeasure: o.unitOfMeasures?.find((a:any) => a.isDefault)?.unitOfMeasure ?? "",
                qtyOrdered: Math.max(o.minimumOrderQty, 1),
            })),
            onComplete: realTimePricingProps => {
                if (realTimePricingProps?.apiResult) {
                    realTimePricingProps.apiResult.realTimePricingResults?.forEach(pricing => {
                        for (const productId in productInfosByProductId) {
                            const productInfo = productInfosByProductId[productId]!;
                            if (
                                productInfo.productId === pricing.productId &&
                                productInfo.unitOfMeasure === pricing.unitOfMeasure
                            ) {
                                productInfo.pricing = pricing;
                            }
                        }
                    });
                } else if (realTimePricingProps.error) {
                    for (const wishListLineId in productInfosByProductId) {
                        productInfosByProductId[wishListLineId]!.failedToLoadPricing = true;
                    }
                }
                props.pricingLoaded = true;
            },
        }),
    );

    await waitFor(() => !!props.pricingLoaded);
};

export const LoadRealTimeInventory: HandlerType = (props: any) => {
    const { products, productInfosByProductId } = props;
    if (!products?.length || true) {
        props.inventoryLoaded = true;
        props.parameter.onSuccess(props);
        return;
    }

    // const productIdsIds = Object.keys(productInfosByProductId);
    // props.dispatch(
    //     loadRealTimeInventory({
    //         productIds: productIdsIds.map(o => productInfosByProductId[o]!.productId),
    //         onComplete: realTimeInventoryProps => {
    //             if (realTimeInventoryProps?.error) {
    //                 productIdsIds.forEach(o => {
    //                     const productInfo = productInfosByProductId[o]!;
    //                     if (productInfo) {
    //                         productInfo.failedToLoadInventory = true;
    //                     }
    //                 });
    //             } else {
    //                 realTimeInventoryProps?.apiResult?.realTimeInventoryResults?.forEach(inventory => {
    //                     productIdsIds.forEach(o => {
    //                         const productInfo = productInfosByProductId[o]!;
    //                         if (productInfo.productId === inventory.productId) {
    //                             productInfo.inventory = inventory;
    //                         }
    //                     });
    //                 });
    //             }

    //             props.inventoryLoaded = true;
    //         },
    //     }),
    // );

    // props.parameter.onSuccess(props);
};

export const chain = [LoadBundledProducts, MapProducts, LoadRealTimePrices, LoadRealTimeInventory];

const loadBundledProducts = createHandlerChainRunner(chain, "LoadBundledProducts");
export default loadBundledProducts;
